import React from "react";
import "./FocusAreaAmericanew.css";
const FocusAreaAmericanew = () => {
  return (
    <>
      <div className="focus-main">
        <div className="heading">
          <h2 className="focus-emea-header">Focus Area</h2>
          <div className="header_focus_emea">
            <img
              src="images/Home/focusarea_line.png"
              alt="header_line"
              className="header_focus_line_img"
            />
          </div>
        </div>

        <div className="america-body">
          <div className="map-image">
            <img src="/images/new/Americas.png" className="america-map" />
          </div>
          <div className="Oracle-container">
            <div className="box-Oracle">
              <img src="/images/Americas/Oracle.png" className="Oracle-img" />

              <h3 className="heading-Oracle">Oracle</h3>
              <ul className="list-Oracle">
                <li className="li-Oracle">AMS Process</li>
                <li className="li-Oracle">Cener</li>
                <li className="li-Oracle">Utilities</li>
                <li className="li-Oracle">Oracle testing fundamentals</li>
                <li className="li-Oracle">Tech Consulting skills</li>
              </ul>
            </div>
          </div>
          <div className="sap-container">
            <div className="box-sap">
              <img src="/images/Americas/Sap.png" className="sap-img" />
              <h3 className="heading-sap">SAP</h3>
              <ul className="list-sap">
                <li className="li-sap">
                  Certification & Bootcamp in Sales & Distribution
                </li>
                <li className="li-sap">
                  Certification & Bootcamp in Extended Warehouse Management
                  (eWM)
                </li>
              </ul>
            </div>
          </div>
          <div className="software-container">
            <div className="box-software">
              <img
                src="/images/Americas/Software.png"
                className="software-img"
              />

              <h3 className="heading-software">Software Engineering</h3>
              <ul className="list-software">
                <li className="li-software">Agentic AI Bootcamp</li>
              </ul>
            </div>
          </div>
          <div className="salesforce-container">
            <div className="box-salesforce">
              <img
                src="/images/Americas/Salesforce.png"
                className="salesforce-img"
              />

              <h3 className="heading-salesforce">Salesforce</h3>
              <div className="data-inlist1">
                <div className="first-list2">
                  <ul className="list-salesforce">
                    <li className="li-salesforce">Omni Studio</li>
                    <li className="li-salesforce">Health Cloud</li>
                    <li className="li-salesforce">Service Cloud</li>
                    <li className="li-salesforce">Experience Cloud</li>
                    <li className="li-salesforce">Certifications</li>
                    <li className="li-salesforce">Industry Learnings</li>
                  </ul>
                </div>
                <div className="second-list2">
                  <ul className="list-salesforce1">
                    <li className="li-salesforce">Vlocity OM & CPQ</li>
                    <li className="li-salesforce">SFDC Best Practices</li>
                    <li className="li-salesforce">Revenue Life Cycle Management</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="dataai-container">
            <div className="box-dataai">
              <img src="/images/Americas/Oracle.png" className="dataai-img" />

              <h3 className="heading-dataai">Data & AI</h3>
              <div className="data-inlist1">
                <div className="first-list1">
                  <ul className="list-dataai">
                    <li className="li-dataai">DataBricks</li>
                    <li className="li-dataai">Ab Initio</li>
                    <li className="li-dataai">Data Warehousing</li>
                    <li className="li-dataai">Big Query</li>
                    <li className="li-dataai">GCP Certification Path</li>
                  </ul>
                </div>
                <div className="second-list1">
                  <ul>
                    <li className="li-dataai">Alteryx</li>
                    <li className="li-dataai">Snowflake</li>
                    <li className="li-dataai">My SQL</li>
                    <li className="li-dataai">Azure, AWS</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FocusAreaAmericanew;
